import AdventureRankPage from "./AdventureRankPage";

export default AdventureRankPage;
